import { Types } from 'service-api'

const getGroupMinimumPrice = (availabilityGroups: Types.AvailabilityGroupClientDto[][] | undefined) => {
  if (!availabilityGroups || availabilityGroups.length == 0 || availabilityGroups[0].length == 0) {
    return {}
  }

  return availabilityGroups.reduce(
    (acc, group) => {
      const offerGroup = group[0].availabilities![0]!
      const accGroup = acc.availabilities![0]!.price!.value!

      if (!offerGroup.available) {
        return acc
      }
      return accGroup < offerGroup.price!.value! ? acc : group[0]
    },
    { availabilities: [{ price: { value: Infinity } }] } as Types.AvailabilityGroupClientDto
  )
}

export const getBaseGroup = (
  serviceTypeName: string,
  petGroup: number,
  availabilityGroups: Types.AvailabilityGroupClientDto[] | Types.AvailabilityGroupClientDto[][] | undefined
) => {
  if (!availabilityGroups) {
    return {}
  }

  if (serviceTypeName === 'boarding') {
    return (availabilityGroups as Types.AvailabilityGroupClientDto[])?.[petGroup] || {}
  }

  return getGroupMinimumPrice(availabilityGroups as Types.AvailabilityGroupClientDto[][])
}
